import React from 'react';

interface FilterMenuToggleProps {
  isOpen: boolean;
  onToggle: () => void;
}

const FilterMenuToggle: React.FC<FilterMenuToggleProps> = ({ isOpen, onToggle }) => (
  <button
    onClick={onToggle}
    className="w-full mb-5 p-2 text-lg cursor-pointer rounded bg-intealth-primary text-white border-none">
    {isOpen ? 'Hide Filters' : 'Show Filters'}
  </button>
);

export default FilterMenuToggle;
